module.exports = __webpack_public_path__ + "static/img/vip_group_bg.b542bba9.png";